module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "app-bar"
  }, [_c('div', {
    staticClass: "app-bar-content"
  }, [_c('div', {
    staticClass: "app-bar-logo"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "toggle-menu",
    on: {
      "click": _vm.toggleCollapseMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "app-bar-user"
  }, [_c('el-dropdown', {
    on: {
      "command": _vm.handleDropdownCommand
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n                    " + _vm._s(_vm.currentUser.name) + " "), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "changePassword"
    }
  }, [_c('span', [_vm._v("Alterar Senha")])]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "logout"
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" "), _c('span', [_vm._v("Sair")])])], 1)], 1)], 1)])]), _vm._v(" "), (_vm.showChangePasswordModal) ? _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.isSubmitted),
      expression: "isSubmitted",
      modifiers: {
        "body": true
      }
    }],
    attrs: {
      "title": "Alteração de senha",
      "size": "tiny",
      "element-loading-text": "Gravando dados...",
      "visible": _vm.showChangePasswordModal
    },
    on: {
      "update:visible": function($event) {
        _vm.showChangePasswordModal = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.changePassword,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Senha atual"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.changePassword.current_password),
      callback: function($$v) {
        _vm.$set(_vm.changePassword, "current_password", $$v)
      },
      expression: "changePassword.current_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Senha"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.changePassword.password),
      callback: function($$v) {
        _vm.$set(_vm.changePassword, "password", $$v)
      },
      expression: "changePassword.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Confirmação"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.changePassword.password_confirmation),
      callback: function($$v) {
        _vm.$set(_vm.changePassword, "password_confirmation", $$v)
      },
      expression: "changePassword.password_confirmation"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.isSubmitted
    },
    on: {
      "click": _vm.onChangePassword
    }
  }, [_vm._v("Salvar nova senha\n                ")])], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('span', {
    staticClass: "text-full"
  }, [_c('strong', [_vm._v("Sistema")]), _vm._v(" Eventos")]), _vm._v(" "), _c('span', {
    staticClass: "text-mobile"
  }, [_c('strong', [_vm._v("SE")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-701926cd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/main/Header.vue
// module id = 766
// module chunks = 2